import { Flex, Text } from '@auviknetworks/iceberg-ui';
import { useTheme } from '@mui/material/styles';
import { OnboardingOktaIntegrationBanner } from 'application/Shared/Components/App/OktaIntegrationBanner';
import React from 'react';
import { useTranslation } from 'react-i18next';

// import { useNavigate } from 'react-router';
import { SuccessBox } from './internal/SuccessBox';

export const QuickScanCompletedStep = ({ integrationType, clientId }) => {
    const theme = useTheme();
    const { t } = useTranslation();

    // Uncomment once we add the table
    // const [numberOfApps, setNumberofApps] = useState(0); // TODO: Update accordingly to incoming data

    // const navigate = useNavigate();

    // useLayoutEffect(() => {
    //     if (!(numberOfApps > 0)) {
    //         navigate('/onboarding/quickScan/completed/deployAgent');
    //     }
    // }, [navigate, numberOfApps]);

    return (
        <Flex
            alignItems="center"
            data-testid="onboardingQuickScanCompletedStep"
            flexDirection="column"
            mt={4}
            mx="4%"
        >
            <Text
                fontSize={['32px', '32px', '32px', 5]}
                color={theme.palette.onboarding.titleTextColor}
                fontWeight="600"
                textAlign="center"
            >
                {t('Onboarding.quickScanSuccess.title')}
            </Text>
            {/* <Text fontSize={4} color={theme.palette.onboarding.titleTextColor} mt={4} textAlign="center">
                {t('Onboarding.quickScanSuccess.subtitle')}
            </Text> */}
            {/* TODO: Add Table */}
            <Flex
                flexDirection="row"
                width="100%"
                justifyContent="space-around"
                sx={{
                    gap: '24px'
                }}
            >
                <Flex>
                    <SuccessBox />
                </Flex>
                <Flex>
                    <OnboardingOktaIntegrationBanner
                        integrationType={integrationType}
                        clientId={clientId}
                    />
                </Flex>
            </Flex>
        </Flex>
    );
};
